import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-secondary-100 flex items-center justify-center">
            <i className="ri-file-unknow-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="text-6xl md:text-8xl font-heading font-black text-foreground-200 select-none pointer-events-none mb-2">
            404
          </h1>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-4">
            Page Not Found
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            The page you are looking for does not exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 mt-8 bg-accent-500 text-background-50 text-sm font-semibold rounded-full hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            Back to Homepage
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}